import React, { useId } from 'react';

const FormTextarea = ({ label, name, value, onChange, onKeyDown, placeholder, rows = 4, ...rest }) => {
    const reactId = useId();
    const fieldId = `${reactId}-${name}`;
    return (
        <div>
            <label htmlFor={fieldId} className="block text-xs font-bold text-neutral-400 uppercase mb-2">
                {label}
            </label>
            <textarea
                id={fieldId}
                name={name}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                rows={rows}
                className="w-full bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/60 focus:border-transparent leading-relaxed"
                {...rest}
            />
        </div>
    );
};

export default FormTextarea;
